import { LoginService, LoginOptions, FixedLoginInfo, RoleGroup, FixedEsiaRole } from "./services/login.service";
import { LoginRepository, AuthUserInfo, IdpEnumItemDto, IdentityProvider } from "./login.repository";
import { LoginDataService } from "./services/login.data.service";
import { LoginOptionsBinder } from "./services/login.data.service";
import { NamedEntityDto } from "approot/global/models/common.model";
import { PasswordRecoveryService } from "./services/password.recovery.service";
import { postTo } from "../../common/js/common.navigation";
import { DialogsService } from "approot/global/providers/uikit.dialogs";

export class EsiaProviders {
	private static esiaProviders: string[] = [ "esia", "esa" ];
	private static esiaProvidersId: IdentityProvider[] = [ IdentityProvider.Esia, IdentityProvider.Esa ];

	static check(provider: string) {
		let ret = this.esiaProviders.indexOf(provider) >= 0;
		return ret;
	}

	static checkID(providerId: IdentityProvider) {
		let ret = this.esiaProvidersId.indexOf(providerId) >= 0;
		return ret;
	}

	static isEsa(provider) {
		let ret = provider == "esa" ||
			provider == IdentityProvider.Esa;
		return ret;
	}
}

class SsoLoginController {
	private idp: string;
	private loginState: string;

	public users: AuthUserInfo[];
	public user: AuthUserInfo;
	public ready: boolean;
	public role?: number;
	public idpInfo: IdpEnumItemDto;

	public personTrusted: boolean;
	public productName: string;
	public loginName: string;
	public password: string;

	public selectUserForIdpLoginMessage: string;
	public errNoUsersLinkedWithIdpAccountMessage: string;
	public continueBindAccountMessage: string;
	public linkMobileAppMessage: string;
	public linkStudentMobileAppMessage: string;
	public authMobileAppMessage: string;
	public schoolAuthMobileAppMessage: string;
	public schoolLinkMobileAppMessage: string;

	public showUsers: boolean = false;
	public showOrganizations: boolean = false;
	public showRoles: boolean = false;

	public activeOrg: NamedEntityDto;
	public activeRole: NamedEntityDto;

	// видимый / невидимый пароль
	public showPassword: boolean = false;
	// режим редактирования логина
	public editLoginName: boolean = false;
	// режим редактирования пароля
	public editPassword: boolean = false;

	public form: ng.IFormController;
	// признак мобильного приложения
	public mobileEntry: boolean;
	public mobileBind: boolean;
	public hasPotentialUsers: boolean;
	public hasSchoolUsers: boolean;
	public isStudent: boolean;

	public epguAuth: boolean;

	public permissionGranted?: boolean;
	public esiaRole?: FixedEsiaRole;
	public esiaPermissions?: boolean;

	public withoutLoggingOut: boolean;

	public esiaMainAuth: boolean = false;

	public timeout: number = 5;
	public stopInterval = null

	public isShowReportBtn: boolean = true

	public remember: boolean = false;

	public isBtnPressed: boolean

	/*@ngInject*/
	constructor(
		private loginService: LoginService,
		private passwordRecoveryService: PasswordRecoveryService,
		private $location: ng.ILocationService,
		private $routeParams: any,
		private loginRepository: LoginRepository,
		public language: any,
		private $scope: ng.IScope,
		private $window,
		private loginDataService: LoginDataService,
		private $interval: ng.IIntervalService,
		private $dialogs: DialogsService
	) {
		this.productName = this.language.Generic.ServAdmin.kNetCity;
		this.init();
	}

	private countDown() {
		return new Promise<void>((resolve) => {
			this.stopInterval = this.$interval(() => {
				this.timeout = this.timeout - 1;
				if (this.timeout == 0) {
					this.$interval.cancel(this.stopInterval);
					this.login()
					resolve();
				}
			}, 1000, 5)
		})
	}

	public stopCountDown() {
		if (this.stopInterval) {
			this.$interval.cancel(this.stopInterval);
			this.stopInterval = null;
			this.timeout = null
		}
	}

	private async initEsiaPermiss() {
		let opts = await this.loginRepository
			.getEsiaPermissOptions(this.loginState);

		this.esiaPermissions = opts.esiaPermissions;
		this.esiaRole = opts.esiaRole;
	}


	private checkEsiaProvider() {
		let ret = EsiaProviders.check(this.idp);
		return ret;
	}

	async init() {
		let searchParams = new URLSearchParams(this.$window.location.search);
		this.loginState = searchParams.get('loginState');
		this.epguAuth = searchParams.has('epgu_auth');
		this.withoutLoggingOut = searchParams.has('withoutLoggingOut');

		// мобильное приложение
		const info = await this.loginService.getMobileInfo(this.loginState);
		this.mobileEntry = info?.isMobile;
		this.mobileBind = info?.mobileBind;

		this.idp = this.$routeParams.idp;

		if (this.checkEsiaProvider()) {
			this.initEsiaPermiss();
		}

		const loginDataReady = this.loginDataService.load()

		let promises = [];

		const getIdpInfo = this.loginRepository.getIdpInfo(this.idp)
			.then(idpInfo => {
				this.idpInfo = idpInfo;
			})
		promises.push(getIdpInfo);

		const getIdpAccountDetails = this.getIdpAccountDetails()
			.catch(error => {
				console.error('getIdpAccountDetails error', error);
				throw error
			});
		promises.push(getIdpAccountDetails);

		promises.push(loginDataReady);

		try {
			await Promise.all(promises)
			this.onReady();
		} catch (error) {
			console.log('error try-catch: ', error)
			this.$dialogs.error('Ошибка').then(() => this.$window.location.href = "/")
		}

	}

	private async getIdpAccountDetails(): Promise<any> {
		let idpAccountInfo = await this.loginService.getIdpAccountInfo(this.idp, this.loginState);
		this.personTrusted = idpAccountInfo.trusted;

		this.users = idpAccountInfo.users;
		this.hasPotentialUsers = this.users && this.users.length > 0;

		this.permissionGranted = idpAccountInfo.permissionGranted;

		// входит студент
		this.isStudent = this.checkStudent();
		// если вход через мобильное приложение
		if (this.mobileEntry) {
			this.users = this.extractMobileAppUsers(this.users);
		}
		else if (this.epguAuth) {
			this.users = this.extractEpguUsers(this.users);
		}
		this.user = this.users[0];
	}

	private checkStudent(): boolean {
		return this.hasPotentialUsers && !this.users.some(usr => usr.isStaff || usr.roles.some(r => r.id == RoleGroup.Parents));
	}

	// извлекает пользователей мобильного приложения
	private extractMobileAppUsers(users: AuthUserInfo[]): AuthUserInfo[] {
		// фильтры
		const schoolUserFilter = userInfo => userInfo.funcType == 'School';
		const parentFilter = userInfo => userInfo.roles.some(rg => rg.id == RoleGroup.Parents);
		// фильтрует школьных пользователей
		let result = users.filter(schoolUserFilter);
		this.hasSchoolUsers = result.length > 0;
		// накладываются дополнительные фильтры по условию
		if (this.mobileBind) {
			// фильтрует только родителей
			result = result.filter(parentFilter);
		}
		else {
			// фильтрует родителей и студентов
			result = result.filter(userInfo => parentFilter(userInfo) || !userInfo.isStaff);
		}
		// результат фильтрации
		return result;
	}

	private extractEpguUsers(users: AuthUserInfo[]): AuthUserInfo[] {
		const parentFilter = userInfo => userInfo.roles.some(rg => rg.id == RoleGroup.Parents);
		var result = users.filter(userInfo => parentFilter(userInfo) || !userInfo.isStaff);
		return result;
	}

	onReady(): void {
		const settings = this.loginDataService.loginData.viewData;
		this.esiaMainAuth = settings.esiaMainAuth


		this.onChangeUser();

		this.buildMessages();
		this.ready = true;

		if (this.role === 0) {
			this.isShowReportBtn = false
		}
		if (this.esiaRole === 3) {
			this.isShowReportBtn = false
		}

		this.$scope.$applyAsync();
		if (this.users.length === 1) {
			if(!this.needInteract()) {
				this.countDown()
			}
		}
		this.remember = this.isShowReportBtn
	}

	onChangeUser(): void {
		this.role = null;
		this.activeRole = null;
		if (this.user?.roles?.length > 0) {
			this.isShowReportBtnFunc(this.user?.roles[0].id)
			this.role = this.user.roles[0].id;
			this.activeRole = this.user.roles[0];
		}
	}

	chooseUser(user: AuthUserInfo): void {
		this.user = user;
		this.isShowReportBtnFunc(user.roles[0].id)
		this.onChangeUser();
	}

	buildMessages(): void {
		this.selectUserForIdpLoginMessage = this.language.Generic.Common.kSelectUserForIdpLogin.replace("{0}", this.idpInfo.title);
		this.errNoUsersLinkedWithIdpAccountMessage = this.language.Generic.Common.kErrNoUsersLinkedWithIdpAccount.replace("{0}", this.idpInfo.title);
		this.continueBindAccountMessage = this.language.Generic.Common.kContinueBindAccount.replace("{0}", this.productName);
		this.linkMobileAppMessage = this.language.Generic.Login.kAccountStaffCannotLinkParentAccount;
		this.linkStudentMobileAppMessage = this.language.Generic.Login.kAccountStudCannotLinkParentAccount;
		this.authMobileAppMessage = this.language.Generic.Login.kAccountStaffCannotLinkMobileApplicSelectStudParents;
		this.schoolLinkMobileAppMessage = this.language.Generic.Login.kAccountUserCannotLinkMobileApplicSelectParents;
		this.schoolAuthMobileAppMessage = this.language.Generic.Login.kAccountUserCannotLinkMobileApplicSelectStudParents;
	}

	displayMobileAppMessage(): string {
		if (this.mobileBind) {
			return this.parentMobileAppBindMessage();
		}
		else {
			return this.parentOrStudentMobileAppLoginMessage();
		}
	}

	private parentOrStudentMobileAppLoginMessage() {
		if (!this.hasSchoolUsers) {
			return this.schoolAuthMobileAppMessage;
		}
		else {
			return this.authMobileAppMessage;
		}
	}

	private parentMobileAppBindMessage() {
		if (!this.hasSchoolUsers) {
			return this.schoolLinkMobileAppMessage;
		}
		else if (this.isStudent) {
			return this.linkStudentMobileAppMessage;
		}
		else {
			return this.linkMobileAppMessage;
		}
	}

	isEsiaKid() {
		return this.esiaRole == FixedEsiaRole.Students;
	}

	isEsiaStaff() {
		return this.esiaRole == FixedEsiaRole.AllStaffs;
	}

	trusted() {
		return this.personTrusted;
	}

	isEsia(): boolean {
		return this.idpInfo && this.idpInfo.id == IdentityProvider.Esia;
	}

	needInteract(): boolean {
		let parentOrStudent = this.role == RoleGroup.Students || this.role == RoleGroup.Parents;
		if (this.mobileEntry) {
			parentOrStudent = true;
		}

		if (!this.user) {
			return false
		}
		if (this.user.binded && parentOrStudent) {
			return false;
		}

		return this.user.mustVerifyLoginPass;
	}

	needChooseRole(): boolean {
		if (this.mobileEntry) {
			return false;
		}
		return this.user && this.user.roles && this.user.roles.length > 1;
	}

	needConsent(): boolean {
		return this.isEsia() && this.trusted() && this.isEsiaKid() && (!this.permissionGranted && !this.hasPotentialUsers);
	}

	needFeedback(): boolean {
		return this.isEsia() && this.trusted() && !this.isEsiaStaff() && (this.permissionGranted && !this.hasPotentialUsers);
	}

	login() {
		if (this.isBtnPressed) {
			return
		}
		this.isBtnPressed = true

		if (this.form.$invalid) {
			this.form.$displayErrors = true;
			return;
		}
		let saveAccount
		if (this.remember) {
			saveAccount = this.remember
		} else {
			saveAccount = this.esiaRole != FixedEsiaRole.AllStaffs
		}
		let loginOptions: LoginOptions = {
			saveAccount: saveAccount,
			loginState: this.loginState
		};

		let fixedLogin: FixedLoginInfo = null;
		if (this.needInteract()) {
			fixedLogin = {
				loginName: this.loginName,
				password: this.password
			};
		}

		// уточняет роль
		if (this.mobileEntry && this.user.roles.length > 1) {
			this.role = RoleGroup.Parents;
		}

		this.stopCountDown()
		new LoginOptionsBinder().execute(loginOptions);

		if (this.user.isServAdmin) {
			this.loginService.servAdminLoginWithIdp(this.user.id, this.idp, this.password, this.loginState)
				.catch(() => this.isBtnPressed = false)
		} else {
			this.loginService.loginWithIdp(this.idp, this.user.id, this.role, loginOptions, fixedLogin)
				.catch(() => this.isBtnPressed = false)
		}
	}

	enter() {
		if (this.needInteract()) {
			this.login();
		}
	}

	logout(): void {
		if (this.isBtnPressed) {
			return
		}
		this.isBtnPressed = true
		this.stopCountDown()
		postTo(`/webapi/sso/${this.idp}/logout`, { loginState: this.loginState }, { method: "GET" });
	}

	bindUser() {
		if (this.isBtnPressed) {
			return
		}
		this.isBtnPressed = true
		const params: any = {
			loginState: this.loginState,
			idpBindUser: "1"
		}
		this.$location.path(`/authorize/login`).search(params);
	}

	recoveryPassword() {
		this.passwordRecoveryService.goToPassRecovery();
	}

	togglePasswordIcon() {
		this.showPassword = !this.showPassword;
	}

	toggleUsers() {
		this.showUsers = !this.showUsers;
		this.stopCountDown()
	}

	toggleRoles() {
		this.showRoles = !this.showRoles;
		this.stopCountDown()
	}

	isShowReportBtnFunc(id: number) {
		// синхронизация роли и есиаРоли
		if (id === 0) { // сотрудник
			this.isShowReportBtn = false
		} else if (id === 2) { // родитель
			this.isShowReportBtn = true
		} else { // ученик
			this.isShowReportBtn = true
		}
	}

	chooseRole(role: NamedEntityDto) {
		this.activeRole = role;
		this.role = role.id;

		this.isShowReportBtnFunc(role.id)
	}

	hasPermissions() {
		if (this.esiaPermissions) {
			return this.esiaPermissions;
		}

		let role = this.user.roles[0].id;

		switch (role) {
			case RoleGroup.Parents:
			case RoleGroup.Students:
				return true;
			default:
				return false;
		}
	}

	calcRole () {
		if (this.role) {
			return this.role
		}
		
		if (!this.esiaRole) {
			if (this.user.roles[0].id === RoleGroup.Staffs) {
				return FixedEsiaRole.AllStaffs
			}
			if (this.user.roles[0].id === RoleGroup.Students) {
				return FixedEsiaRole.Students
			}
			if (this.user.roles[0].id === RoleGroup.Parents) {
				return FixedEsiaRole.Parents
			}
		} else {
			return this.esiaRole
		}
	}

	openReport() {
		if (this.isBtnPressed) {
			return
		}
		this.isBtnPressed = true
		this.stopCountDown()

		if (!this.personTrusted) {
			this.$dialogs.error('Отсутствует возможность для создания запроса на предоставление доступа. Ваша учетная запись не является подтвержденной.')
			this.isBtnPressed = false
			return
		}
		const params: any = {
			loginState: this.loginState,
			esiaRole: this.calcRole(),
			idp: this.idp
		};

		if (this.hasPermissions()) {
			params.esia_permissions = "1";
		}
		
		this.$location.path(`/authorize/report`).search(params);
	}

	toggleRemember() {
		this.remember = !this.remember;
	}
}

export const SsoLoginComponent = {
	templateUrl: "/static/dist/app/login/sso.login.component.html",
	controllerAs: "$ctrl",
	controller: SsoLoginController
}
